export function safeParseJson(value) {
    try {
        return JSON.parse(value);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('safeParseJson error:', error);
        return null;
    }
}
